var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13V19.0001C12.6537 19.0001 9.34634 19.0001 2.00004 19.0001V13H0V21.0003C0 22.0999 0.899943 23.0002 1.99991 23.0002H20.0001C21.1001 23.0002 22 22.1002 22 21.0003V13H20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 9.00013V0H8.99996V9.00013H4L11.0002 16L18.0001 9.00013H13.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadPackage);
export default __webpack_public_path__ + "static/media/icon_download_package.84c6513951f9f0e16981a7cc3915fa72.svg";
export { ForwardRef as ReactComponent };